import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { ServiceIcon } from '../ServiceIcon';
import { serviceLinks } from '../../data/services';
type RelatedServicesProps = {
  slugs: string[];
};
export function RelatedServices({
  slugs
}: RelatedServicesProps) {
  const related = serviceLinks.filter(s => slugs.includes(s.slug));
  if (related.length === 0) return null;
  return <section className="bg-canvas pb-20 lg:pb-24" data-id="element-340" data-mp="3fui33zk53bt9">
      <div className="mx-auto max-w-7xl border-t border-line px-5 pt-14 lg:px-8" data-id="element-341" data-mp="3jus5714t9i2u">
        <h2 className="font-display text-3xl font-extrabold uppercase text-ink" data-id="element-342" data-mp="3jso22leqkn3m">Related services</h2>
        <ul className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-343" data-mp="35xdd1on6aw76">
          {related.map(s => <li key={s.slug} data-id="element-344" data-mp="3avwxtlq161xy">
              <Link to={`/${s.slug}`} className="group flex h-full items-center gap-3 rounded-xl bg-white px-4 py-4 font-display text-xl font-bold text-ink ring-1 ring-line transition-colors duration-150 hover:ring-brand" data-id="element-345" data-mp="1ufkoilzhta99">
                <ServiceIcon name={s.icon} className="h-5 w-5 shrink-0 text-brand" data-id="element-346" data-mp="17d4mh0bvymti" />
                <span className="flex-1" data-id="element-347" data-mp="17f7iq23mtc6o">{s.name}</span>
                <ArrowRightIcon className="h-4 w-4 text-ink-muted transition-transform duration-150 group-hover:translate-x-0.5 group-hover:text-brand" aria-hidden="true" data-id="element-348" data-mp="1ldxgzl26thwm" />
              </Link>
            </li>)}
        </ul>
      </div>
    </section>;
}